// @flow

export { validator as brazilianValidator } from './validator';
export { validateBrazilianZipcode } from './brazilian-zipcode';
